import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FlightTicketPropType } from 'PropTypes';
import { Row, Col } from 'react-bootstrap';

import StatusStaffTabsRow from 'Components/StatusStaffTabsRow';
import RequestInformationCard from 'Views/TicketProfile/Components/RequestInformationCard';
import TicketIdentifiersCard from 'Views/TicketProfile/Components/TicketIdentifiersCard';
import { FlightTicketApiService } from 'Services/ApiServices';

const FlyToWorkTicketInformationTab = (props) => {
  const { flyToWorkTicketInfo } = props;
  const [tppMessage, setTppMessage] = useState('');
  const [tppMessageColor, setTppMessageColor] = useState('black');
  const [tppMessageType, setTppMessageType] = useState('info'); // 'success', 'error', 'info'

  const checkTppRecord = async (mplid, staffId) => {
    if (!mplid || !staffId) {
      setTppMessage('MPLID or Staff ID is missing');
      setTppMessageColor('red');
      setTppMessageType('error');
      return;
    }

    try {
      const result = await FlightTicketApiService.checkTppAssignment(mplid, staffId);
      if (result && result.data && result.data.exists === true) {
        setTppMessage('TPP assignment found successfully.');
        setTppMessageColor('green');
        setTppMessageType('success');
      } else {
        setTppMessage('TPP assignment not found.');
        setTppMessageColor('red');
        setTppMessageType('error');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Assignment not found';
      setTppMessage(errorMessage);
      setTppMessageColor('orange');
      setTppMessageType('info');
    }
  };

  const checkEcRecord = async (ecPositionId, sliceId, staffId) => {
    if (!ecPositionId || !sliceId || !staffId) {
      setTppMessage('EC Position ID, Slice ID or Staff ID is missing');
      setTppMessageColor('red');
      setTppMessageType('error');
      return;
    }

    try {
      const result = await FlightTicketApiService.checkEcAssignment(ecPositionId, sliceId, staffId);
      if (result && result.data && result.data.exists === true) {
        setTppMessage('EC assignment found in TPP.');
        setTppMessageColor('green');
        setTppMessageType('success');
      } else {
        setTppMessage('EC assignment not found in TPP.');
        setTppMessageColor('red');
        setTppMessageType('error');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'EC assignment not found';
      setTppMessage(errorMessage);
      setTppMessageColor('orange');
      setTppMessageType('info');
    }
  };

  useEffect(() => {
    if (flyToWorkTicketInfo.assignmentType === 'ec') {
      checkEcRecord(flyToWorkTicketInfo.ecPositionId, flyToWorkTicketInfo.sliceId, flyToWorkTicketInfo.originalStaffId);
      return;
    }
    checkTppRecord(flyToWorkTicketInfo.mplid, flyToWorkTicketInfo.originalStaffId);
  }, [flyToWorkTicketInfo]);

  // Choose icon based on message type
  const getIconClass = () => {
    if (tppMessageType === 'success') return 'fa fa-check fa-2x';
    if (tppMessageType === 'error') return 'fa fa-times fa-2x';
    return 'times fa-2x';
  };

  return (
    <React.Fragment>
      <StatusStaffTabsRow flyToWorkTicketInfo={flyToWorkTicketInfo} />
      <hr style={{ marginTop: 0 }} />
      <TicketIdentifiersCard flyToWorkTicketInfo={flyToWorkTicketInfo} />
      <RequestInformationCard flyToWorkTicketInfo={flyToWorkTicketInfo} />
      <Row>
        <Col>
          {tppMessage && (
            <div
              style={{
                color: tppMessageColor,
                marginBottom: 10,
                marginTop: 20,
                display: 'flex',
                alignItems: 'center',
                fontWeight: 500,
              }}
            >
              <i className={getIconClass()} style={{ color: tppMessageColor, marginRight: 10 }} aria-hidden="true" />
              {tppMessage}
            </div>
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

FlyToWorkTicketInformationTab.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
  setRefreshComponent: PropTypes.func,
  refreshComponent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FlyToWorkTicketInformationTab;
